export default {
  STOP_ALL_PROCESSES(state, docs){
    state.stopProcesses = docs
  },
};
